var _style, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#241F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,25.1c-0.4,0-0.8-0.1-1.1-0.4L25,7.1L4.2,24.7c-0.7,0.6-1.8,0.5-2.5-0.2C1.1,23.7,1.2,22.6,2,22L23.9,3.5 c0.7-0.6,1.6-0.6,2.3,0L48,22c0.7,0.6,0.8,1.7,0.2,2.5C47.9,24.9,47.4,25.1,46.9,25.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,45.5H12.3c-2.8,0-5-2.3-5-5V18.3c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v22.1c0,0.8,0.7,1.5,1.5,1.5h25.3 c0.8,0,1.5-0.7,1.5-1.5V18.3c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v22.2C42.6,43.2,40.4,45.5,37.6,45.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2,45.5H18.9c-1,0-1.8-0.8-1.8-1.8v-14c0-1,0.8-1.8,1.8-1.8h12.3c1,0,1.8,0.8,1.8,1.8v14 C32.9,44.7,32.1,45.5,31.2,45.5z M20.6,42h8.8V31.5h-8.8V42z"
  }))));
}

export default SvgHome;